module.exports = __webpack_public_path__ + "img/belgium-cancer-female.04770463.png";